
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const supabaseUrl = "https://bfbacpuuannuhqqlkdxm.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJmYmFjcHV1YW5udWhxcWxrZHhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzMzNTg2NDcsImV4cCI6MjA0ODkzNDY0N30.v72Ptw5kMi2Jxi8ZuFg25x7j9CzSpKlB48Xxugf2Iao";
const serviceRoleKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJmYmFjcHV1YW5udWhxcWxrZHhtIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTczMzM1ODY0NywiZXhwIjoyMDQ4OTM0NjQ3fQ.5OwRuFJqdC5hCKtcLomenkCI2RD48YKlnC1HX3yPeGA";

// Create the admin client with service role key
export const adminSupabase = createClient<Database>(supabaseUrl, serviceRoleKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false
  }
});

// Create the regular client with anon key
export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
